<template>
    <div class="row">
        <div :class="'col-' + (hasHelp ? '10' : '12') + ' col-md-' + (hasHelp ? (left - 1) : left)">
            <label>
                <slot name="label"></slot>
                <slot name="labelhelptext"></slot>
            </label>
        </div>
        <div :class="'col-' + (hasHelp ? '10' : '12') + ' col-md-' + (hasHelp ? (right - 1) : right)">
            <slot name="input"></slot>
        </div>
        <div v-if="hasHelp" class="col-2 col-md-1">
            <a v-if="!!help && help !== ''" data-popover-placement="bottom" :data-popover-title="help.split('||')[0]" :data-popover-content="help.split('||')[1]" href="#" class="helpBtn addPopover activePopover" data-original-title="" title=""><i tabindex="-1" class="flaticon-conversation6"></i></a>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'np-responsive',
        inheritAttrs: false,
        props:['split', 'help'], //split is between 0 and 1 and fractional factor of 12 i.e 0.3, 0.4, 0.6
        computed: {
            _split: function () {
                if (isNaN(this.split)) {
                    return 0;
                } else {
                    return this.split;
                }
            },
            hasHelp: function () {
                return !!this.help;
            },
            left: function() {
                return Math.round(12 * (this._split === 0 ? 1 : this._split))
            },
            right: function() {
                return Math.round(12 * (1 - this._split))
            }
        }
    }
</script>
